import React from 'react';
import MainNav from './MainNav';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import SettingsRoute from './SettingsRoute';
import SettingsSavedNotification from './SettingsSavedNotification';

const SettingsWrap = () => {

	return (
		<Router>
			<MainNav/>
			<SettingsSavedNotification/>
			<Routes>
				<Route path="*" element={ <SettingsRoute /> } />
			</Routes>
		</Router>
	);
};

export default SettingsWrap;
